import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/ui/Button';
import styles from './EmptyStateMessage.module.css';

interface EmptyStateMessageProps {
  onChangeEnergy: () => void;
}

// PARA-105, AC-E2: сообщение при 404 от procrastination-suggestion, без падения UI.
// PARA-122: иконка-бейдж (круг 56px + пунктирный внутренний круг) + title, ниже body
// (образец components/procrastination/EmptyStateMessage.jsx). Тон — ободряющий, без осуждения.
export function EmptyStateMessage({ onChangeEnergy }: EmptyStateMessageProps): JSX.Element {
  const { t } = useTranslation('procrastination');

  return (
    <div className={styles.wrapper} data-testid="empty-state-message">
      <span className={styles.iconBadge} aria-hidden="true">
        <span className={styles.iconInner} />
      </span>
      <div className={styles.title}>{t('empty.title')}</div>
      <p className={styles.message}>{t('empty.message')}</p>
      <Button variant="secondary" onClick={onChangeEnergy}>
        {t('empty.changeEnergy')}
      </Button>
    </div>
  );
}
